import React from 'react';
import PropTypes from 'prop-types';
import { trafficColorsClass } from 'utils/general';

class Bubbles extends React.Component {
  componentDidMount() {
    this.setSvg(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setSvg(nextProps);
  }

  setSvg(props) {
    const { data, id } = props;
    const parsedData = this.parseData(data);
    const margin = { top: 10, right: 20, bottom: 90, left: 30 };
    const width = 400 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;
    let svg = d3.select('svg');

    // Remove svg to avoid append
    const svgEl = d3.select(`#${id} svg`)[0];
    svgEl[0] && svgEl[0].remove();


    const x = d3.scale.linear()
      .domain([-500000, 5000000])
      .range([0, width]);

    const y = d3.scale.linear()
      .domain([-20, 100])
      .range([height, 0]);

    const xAxis = d3.svg.axis()
      .scale(x)
      .ticks(7)
      .orient('bottom');

    const yAxis = d3.svg.axis()
      .scale(y)
      .orient('left')
      .innerTickSize(-width)
      .tickPadding(10)
      .ticks(5);

    svg = d3.select(`#${id}`).append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
        .attr('transform', `translate(${margin.left} , ${margin.top})`);

    svg.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0, ${height})`)
      .call(xAxis)
      .selectAll('text')
        .attr('dx', '-10px')
        .attr('class', 'x-label')
        .attr('transform', 'rotate(-45)')
        .style('text-anchor', 'end');

    svg.append('g')
      .attr('class', 'y axis')
      .call(yAxis)
      .selectAll('text')
        .attr('class', 'y-label')
        .style('text-anchor', 'end');

    this.appendBubbles(parsedData, svg, x, y);
  }

  getBubbleSize(value) {
    const parseValue = value;
    switch (true) {
      case (parseValue < 10): return 3;
      case (parseValue < 30): return 4;
      case (parseValue < 50): return 5;
      case (parseValue < 100): return 7;
      case (parseValue < 200): return 9;
      case (parseValue < 300): return 10;
      case (parseValue < 900): return 15;
      default: return 20;
    }
  }

  appendBubbles(data, svg, x, y) {
    const { country } = this.props;
    const tooltip = d3.selectAll('.c-tooltip-graph');

    svg.append('g')
      .attr('class', 'bubbles')
      .selectAll('bubble')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', d => `bubble ${trafficColorsClass(d.y)}${d.label === country ? ' -current' : ''}`)
      .attr('cx', d => x(d.x))
      .attr('cy', d => y(d.y))
      .attr('r', d => this.getBubbleSize(d.size))
      .attr('cursor', 'pointer')
      .on('mousemove', (d) => {
        tooltip
         .style('left', `${d3.event.pageX - 50}px`)
         .style('top', `${d3.event.pageY - 70}px`)
         .style('display', 'flex')
         .html(`<span class="title">${d.label}</span><span class="value">${d.y}</span>`);
      })
      .on('mouseout', () => tooltip.style('display', 'none'));

    // const current = d3.selectAll('.bubble.-current');
    //
    // current.length && tooltip
    //  .style('left', `${current[0][0].getBoundingClientRect().left + 20}px`)
    //  .style('top', `${current[0][0].getBoundingClientRect().top - 40}px`)
    //  .style('display', 'flex')
    //  .html(`<span class="title">${this.props.country}</span><span class="value">28</span>`);
  }

  parseData(data) {
    return data ? data.sort((a, b) => b.size - a.size).map(d => ({
      label: d['country-sector'].country.name || '',
      x: d.y,
      y: d.x,
      c: d.x,
      size: d.size
    })) : [];
  }

  render() {
    return (
      <div className="c-bubbles">
        <div id={this.props.id} className="bubbles"></div>
        <div className="legend">
          {/* <ul className="legend-list">
            <li className="item"><span className="icon -law"></span>Law</li>
            <li className="item"><span className="icon -practice"></span>Practice</li>
            <li className="item"><span className="icon -gap"></span>Gap</li>
          </ul> */}
        </div>
      </div>
    );
  }
}

Bubbles.propTypes = {
  data: PropTypes.array,
  country: PropTypes.string,
  id: PropTypes.string.isRequired
};

export default Bubbles;



// WEBPACK FOOTER //
// ./app/components/common/charts/Bubbles.jsx